import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { includes } from 'lodash';

import FlashMessagesContainer from 'v-c/FlashMessages';
import withMessages from 'component-utilities/intl';

export default function initFlashMessages(connect, localizationPath = 'app.flash') {
  @withMessages
  class FlashMessages extends Component {
    static propTypes = {
      notifyHeight: PropTypes.func,
      flashMessages: PropTypes.shape({
        indicators: PropTypes.array.isRequired,
        activeViewId: PropTypes.string.isRequired,
      }).isRequired,
      getMessage: PropTypes.func.isRequired,
    };

    static defaultProps = {
      notifyHeight: () => {},
    };

    componentWillUpdate() {
      this.props.notifyHeight();
    }

    get indicatorsForTheCurrentView() {
      const { activeViewId, indicators } = this.props.flashMessages;

      return indicators.filter(indicator => includes(indicator.validViews, activeViewId));
    }

    messages() {
      return this.indicatorsForTheCurrentView.map(indicator => ({
        indicator: indicator.message,
        content: this.props.getMessage(`${localizationPath}.${indicator.message}`),
      }));
    }

    render() {
      if (!this.indicatorsForTheCurrentView.length) {
        return null;
      }

      return <FlashMessagesContainer messages={this.messages()} />;
    }
  }

  return connect(FlashMessages);
}
